import { render, staticRenderFns } from "./DirectInvite.vue?vue&type=template&id=84aeb762&scoped=true&"
import script from "./DirectInvite.vue?vue&type=script&lang=js&"
export * from "./DirectInvite.vue?vue&type=script&lang=js&"
import style0 from "./DirectInvite.vue?vue&type=style&index=0&id=84aeb762&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84aeb762",
  null
  
)

export default component.exports